export const STICKER_VARIANTS = {
// --- BMR landing page ---
  HEART_PLUS: "heartPlusSticker",
  HUMAN_GRADE: "humanGradeSticker",
  CROSS: "crossSticker",
  NUTRITIONALLY_BALANCED: "nutritionallyBalancedSticker",
  GENTLY_COOKED: "gentlyCookedSticker",

  // --- SUF v2 signup flow ---
  PREMIUM_MEAT: "premiumMeatSticker",
  VET_FORMULATED: "vetFormulatedSticker",
  NO_GRAINS: "noGrainsSticker",
  HEART_PLUS_FREE_GIFT: "heartPlusFreeGiftSticker",
  HEART_PLUS_NO_STRINGS: "heartPlusNoStringsSticker",
  FIFTY_OFF: "fiftyOffSticker",
  FROZEN: "frozen",

  // Misc
  PREMIUM_MEAT_SAND: "premiumMeatStickerSand",
  VET_FORMULATED_SAND: "vetFormulatedStickerSand",
  NO_GRAINS_SAND: "noGrainsStickerSand",
} as const;

export type StickerVariant =
  typeof STICKER_VARIANTS[keyof typeof STICKER_VARIANTS];

export type StickerSize = "sm" | "md" | "lg" | "xl";

export const STICKER_SIZE_CLASSES: Record<StickerSize, string> = {
  sm: "w-20 h-20", // 80px
  md: "w-24 h-24", // 96px
  lg: "w-28 h-28", // 112px
  xl: "w-36 h-36", // 144px
};

export const STICKER_MD_SIZE_CLASSES: Record<StickerSize, string> = {
  sm: "md:w-20 md:h-20",
  md: "md:w-24 md:h-24",
  lg: "md:w-28 md:h-28",
  xl: "md:w-36 md:h-36",
};

